/**
 * This file defines the roles and permissions for the application using CASL.
 * It maps user roles to specific actions (can).
 */

import { Ad6Constants } from '@shared/constants';

import type { RoleDefinition } from './types';

/**
 * Global role definitions.
 * Roles are mapped from Keycloak tokens. The system evaluates all roles a user has
 * and combines them based on priority.
 */
export const ROLE_PERMISSIONS: RoleDefinition[] = [
  {
    name: 'default',
    priority: -1,
    define: ({ cannot }): void => {
      // Baseline veiligheid: blokkeer standaard alle beheeracties
      cannot('manage', 'all');
    },
  },
  {
    name: Ad6Constants.ROLE_AD6USER,
    priority: 10,
    define: ({ can, cannot }): void => {
      can('manage', 'all'); // Standaard AD6 gebruikers mogen alles behalve onderstaande beheeracties

      cannot('manage', 'config'); // Configuratie mag niet beheerd worden
      cannot('manage', 'config.appConfig'); // App-configuratie mag niet beheerd worden
      cannot('manage', 'taskManagement'); // Taakbeheer mag niet beheerd worden
      cannot('manage', 'translation'); // Translations mag niet beheerd worden
      cannot('execute', 'participant.importMembers'); // Importeren van deelnemers mag niet uitgevoerd worden
      cannot('manage', 'imageManagement.collection');
      cannot(['update', 'delete', 'create'], 'event.setting'); // Instellingen van evenementen mogen niet beheerd worden
      cannot(['update', 'delete', 'create'], 'event'); // Evenementen mogen niet beheerd worden, behalve het bekijken ervan
      cannot(['update', 'delete', 'create'], 'event.sub'); // Sub-evenementen mogen niet beheerd worden, behalve het bekijken ervan
    },
  },
  {
    name: Ad6Constants.ROLE_ADMINISTRATORS,
    priority: 100,
    define: ({ can }): void => {
      // De beheerder mag alles.
      can('manage', 'all');
    },
  },
];
